var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container-fluid table-container" },
    [
      _c("loading", {
        attrs: { active: _vm.loading, "can-cancel": false },
        on: {
          "update:active": function ($event) {
            _vm.loading = $event
          },
        },
      }),
      !(_vm.data.selected.unit || (_vm.data.selected.unit || {}).id)
        ? _c(
            "div",
            {
              staticClass: "alert alert-danger text-center",
              attrs: { role: "alert" },
            },
            [_c("h2", [_vm._v(_vm._s(_vm.$t("pleaseSelectUnit")))])]
          )
        : _vm._e(),
      _vm.expanded ? _c("acm-tooltip") : _vm._e(),
      !_vm.data.navBarRefresh &&
      _vm.data.selected.unit &&
      _vm.data.selected.unit.id
        ? _c(
            "div",
            [
              _c("div", { staticClass: "filter-wrapper" }, [
                _c(
                  "div",
                  {
                    staticClass: "filter-show",
                    class: { "visible-button": _vm.filter.visible },
                    on: {
                      click: function ($event) {
                        _vm.filter.visible = !_vm.filter.visible
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "content" }, [
                      _c(
                        "div",
                        { staticClass: "d-inline-flex" },
                        [
                          _c("div", { staticClass: "pr-3" }, [
                            _vm._v(" " + _vm._s(_vm.$t("filter")) + " "),
                          ]),
                          _c("font-awesome-icon", {
                            attrs: { icon: "angle-down" },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass: "filter-container pt-3 pb-2 pl-2 pr-2",
                    class: [{ visible: _vm.filter.visible }],
                  },
                  [
                    _c("h6", [_vm._v(_vm._s(_vm.$t("filter")))]),
                    _c("div", { staticClass: "input-group pb-2" }, [
                      _c("div", { staticClass: "input-group-prepend" }, [
                        _c("span", { staticClass: "input-group-text" }, [
                          _vm._v(_vm._s(_vm.$t("outageId")) + ":"),
                        ]),
                      ]),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.filter.selectedOutageId,
                              expression: "filter.selectedOutageId",
                            },
                          ],
                          staticClass: "form-control",
                          on: {
                            change: function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.filter,
                                "selectedOutageId",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            },
                          },
                        },
                        [
                          _c("option", { domProps: { value: null } }, [
                            _vm._v(" " + _vm._s(_vm.$t("none")) + " "),
                          ]),
                          _vm._l(_vm.filter.outageIds, function (outageId, i) {
                            return _c("option", { key: outageId.id + i }, [
                              _vm._v(" " + _vm._s(outageId.id) + " "),
                            ])
                          }),
                        ],
                        2
                      ),
                    ]),
                    _c("div", { staticClass: "input-group pb-2" }, [
                      _c("div", { staticClass: "input-group-prepend" }, [
                        _c("span", { staticClass: "input-group-text" }, [
                          _vm._v(_vm._s(_vm.$t("globalProjectId")) + ":"),
                        ]),
                      ]),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.filter.selectedGlobalProjectId,
                              expression: "filter.selectedGlobalProjectId",
                            },
                          ],
                          staticClass: "form-control",
                          on: {
                            change: [
                              function ($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function (o) {
                                    return o.selected
                                  })
                                  .map(function (o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  _vm.filter,
                                  "selectedGlobalProjectId",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              },
                              function ($event) {
                                return _vm.onGlobalProjectIdFilterChange($event)
                              },
                            ],
                          },
                        },
                        [
                          _c("option", { domProps: { value: null } }, [
                            _vm._v(" " + _vm._s(_vm.$t("none")) + " "),
                          ]),
                          _vm._l(
                            _vm.filter.globalProjectIds,
                            function (globalProjectId) {
                              return _c(
                                "option",
                                {
                                  key: globalProjectId,
                                  domProps: { value: globalProjectId },
                                },
                                [_vm._v(" " + _vm._s(globalProjectId) + " ")]
                              )
                            }
                          ),
                        ],
                        2
                      ),
                    ]),
                    _c("div", { staticClass: "input-group pb-2" }, [
                      _c("div", { staticClass: "input-group-prepend" }, [
                        _c("span", { staticClass: "input-group-text" }, [
                          _vm._v(_vm._s(_vm.$t("projectName")) + ":"),
                        ]),
                      ]),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.filter.selectedProject,
                              expression: "filter.selectedProject",
                            },
                          ],
                          staticClass: "form-control",
                          on: {
                            change: function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.filter,
                                "selectedProject",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            },
                          },
                        },
                        [
                          _c("option", { domProps: { value: null } }, [
                            _vm._v(" " + _vm._s(_vm.$t("none")) + " "),
                          ]),
                          _vm._l(_vm.filter.projects, function (project) {
                            return _c(
                              "option",
                              {
                                key: project.name,
                                domProps: { value: project },
                              },
                              [_vm._v(" " + _vm._s(project.name) + " ")]
                            )
                          }),
                        ],
                        2
                      ),
                    ]),
                    _c("div", { staticClass: "input-group pb-2" }, [
                      _c("div", { staticClass: "input-group-prepend" }, [
                        _c("span", { staticClass: "input-group-text" }, [
                          _vm._v(_vm._s(_vm.$t("maintenanceOrRiskId")) + ":"),
                        ]),
                      ]),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.filter.selectedMaintenanceOrRiskId,
                              expression: "filter.selectedMaintenanceOrRiskId",
                            },
                          ],
                          staticClass: "form-control",
                          on: {
                            change: function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.filter,
                                "selectedMaintenanceOrRiskId",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            },
                          },
                        },
                        [
                          _c("option", { domProps: { value: null } }, [
                            _vm._v(" " + _vm._s(_vm.$t("none")) + " "),
                          ]),
                          _vm._l(
                            _vm.filter.maintenanceOrRiskIds,
                            function (id) {
                              return _c(
                                "option",
                                { key: id, domProps: { value: id } },
                                [_vm._v(" " + _vm._s(id) + " ")]
                              )
                            }
                          ),
                        ],
                        2
                      ),
                    ]),
                    _c("div", { staticClass: "input-group pb-2" }, [
                      _c("div", { staticClass: "input-group-prepend" }, [
                        _c("span", { staticClass: "input-group-text" }, [
                          _vm._v(_vm._s(_vm.$t("costGreaterOrEqualTo")) + ":"),
                        ]),
                      ]),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.filter.minimumCost,
                            expression: "filter.minimumCost",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: { type: "number", min: "0" },
                        domProps: { value: _vm.filter.minimumCost },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.filter,
                              "minimumCost",
                              $event.target.value
                            )
                          },
                        },
                      }),
                      _c("div", { staticClass: "input-group-append" }, [
                        _c(
                          "span",
                          {
                            staticClass: "input-group-text",
                            staticStyle: { width: "50px" },
                          },
                          [_vm._v("(K" + _vm._s(_vm.getCurrencySymbol()) + ")")]
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "input-group pb-2" }, [
                      _c("div", { staticClass: "input-group-prepend" }, [
                        _c("span", { staticClass: "input-group-text" }, [
                          _vm._v(
                            _vm._s(_vm.$t("showOnlyFutureActivities")) + ":"
                          ),
                        ]),
                      ]),
                      _c("div", { staticClass: "input-group-append" }, [
                        _c(
                          "div",
                          {
                            staticClass: "input-group-text",
                            staticStyle: { width: "40px" },
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.filter.showOnlyFutureActivities,
                                  expression: "filter.showOnlyFutureActivities",
                                },
                              ],
                              attrs: { type: "checkbox" },
                              domProps: {
                                checked: Array.isArray(
                                  _vm.filter.showOnlyFutureActivities
                                )
                                  ? _vm._i(
                                      _vm.filter.showOnlyFutureActivities,
                                      null
                                    ) > -1
                                  : _vm.filter.showOnlyFutureActivities,
                              },
                              on: {
                                change: function ($event) {
                                  var $$a = _vm.filter.showOnlyFutureActivities,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        _vm.$set(
                                          _vm.filter,
                                          "showOnlyFutureActivities",
                                          $$a.concat([$$v])
                                        )
                                    } else {
                                      $$i > -1 &&
                                        _vm.$set(
                                          _vm.filter,
                                          "showOnlyFutureActivities",
                                          $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1))
                                        )
                                    }
                                  } else {
                                    _vm.$set(
                                      _vm.filter,
                                      "showOnlyFutureActivities",
                                      $$c
                                    )
                                  }
                                },
                              },
                            }),
                          ]
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "input-group pb-2" }, [
                      _c("div", { staticClass: "input-group-prepend" }, [
                        _c("span", { staticClass: "input-group-text" }, [
                          _vm._v(
                            _vm._s(_vm.$t("showOnlyMainStrategies")) + ":"
                          ),
                        ]),
                      ]),
                      _c("div", { staticClass: "input-group-append" }, [
                        _c(
                          "div",
                          {
                            staticClass: "input-group-text",
                            staticStyle: { width: "40px" },
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.filter.showOnlyMainActivities,
                                  expression: "filter.showOnlyMainActivities",
                                },
                              ],
                              attrs: { type: "checkbox" },
                              domProps: {
                                checked: Array.isArray(
                                  _vm.filter.showOnlyMainActivities
                                )
                                  ? _vm._i(
                                      _vm.filter.showOnlyMainActivities,
                                      null
                                    ) > -1
                                  : _vm.filter.showOnlyMainActivities,
                              },
                              on: {
                                change: function ($event) {
                                  var $$a = _vm.filter.showOnlyMainActivities,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        _vm.$set(
                                          _vm.filter,
                                          "showOnlyMainActivities",
                                          $$a.concat([$$v])
                                        )
                                    } else {
                                      $$i > -1 &&
                                        _vm.$set(
                                          _vm.filter,
                                          "showOnlyMainActivities",
                                          $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1))
                                        )
                                    }
                                  } else {
                                    _vm.$set(
                                      _vm.filter,
                                      "showOnlyMainActivities",
                                      $$c
                                    )
                                  }
                                },
                              },
                            }),
                          ]
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "float-right" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-sm btn-primary mt-1",
                          attrs: {
                            type: "button",
                            disabled: _vm.noFilterSelected(),
                          },
                          on: {
                            click: function ($event) {
                              return _vm.filterTable()
                            },
                          },
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("filter")) + " ")]
                      ),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-sm btn-primary mt-1",
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              return _vm.clearFilter()
                            },
                          },
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("clear")) + " ")]
                      ),
                    ]),
                  ]
                ),
              ]),
              _c("div", { staticClass: "header-row pl-3" }, [
                _c(
                  "div",
                  {
                    staticClass: "_col-4 pl-3 header-row-freez pr-4",
                    class: { expanded: _vm.expanded },
                    style: { width: _vm.leftPaneWidth + "px" },
                  },
                  [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-12 mt-1 pl-0" }, [
                        _c("div", { staticClass: "row table-logo" }, [
                          _c(
                            "div",
                            {
                              staticClass: "pt-3 table-name",
                              class: {
                                "col-9": _vm.expanded,
                                "col-12": !_vm.expanded,
                              },
                            },
                            [
                              _c("h2", { staticClass: "title" }, [
                                _vm._v(" " + _vm._s(_vm.$t("table")) + " "),
                              ]),
                            ]
                          ),
                          _vm.hasValidACMCode("test")
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "col-3 pr-0 acm-unit-donut-container",
                                },
                                [
                                  _c("span", [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "acm-donut",
                                        on: {
                                          click: function ($event) {
                                            return _vm.showACMTooltip(
                                              _vm.acmUnitItem
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "donut-size acm-unit-donut",
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "pie-acm",
                                                attrs: {
                                                  title:
                                                    _vm.$t("numberRedAlerts"),
                                                },
                                              },
                                              [
                                                _vm.acmDonutStyles[
                                                  _vm.ACM_UNIT_DONUT
                                                ]
                                                  ? _c(
                                                      "svg",
                                                      {
                                                        staticClass:
                                                          "donut shadow",
                                                        attrs: {
                                                          width: "100%",
                                                          height: "100%",
                                                          viewBox: "5 5 32 32",
                                                        },
                                                      },
                                                      [
                                                        _c("circle", {
                                                          staticClass:
                                                            "donut-hole",
                                                          attrs: {
                                                            cx: "21",
                                                            cy: "21",
                                                            r: "15.91549430918954",
                                                            fill: "#fff",
                                                          },
                                                        }),
                                                        _c("circle", {
                                                          staticClass:
                                                            "donut-ring",
                                                          attrs: {
                                                            cx: "21",
                                                            cy: "21",
                                                            r: "15.91549430918954",
                                                            fill: "transparent",
                                                            stroke: "#d2d3d4",
                                                          },
                                                        }),
                                                        _c("circle", {
                                                          staticClass:
                                                            "alert_severities1 donut-segment",
                                                          attrs: {
                                                            "stroke-dashoffset":
                                                              _vm
                                                                .acmDonutStyles[
                                                                _vm
                                                                  .ACM_UNIT_DONUT
                                                              ][
                                                                _vm.ACMHelper
                                                                  .SEVERITY1
                                                              ][
                                                                _vm.ACMHelper
                                                                  .STROKE_DASHOFFSET
                                                              ],
                                                            "stroke-dasharray":
                                                              _vm
                                                                .acmDonutStyles[
                                                                _vm
                                                                  .ACM_UNIT_DONUT
                                                              ][
                                                                _vm.ACMHelper
                                                                  .SEVERITY1
                                                              ][
                                                                _vm.ACMHelper
                                                                  .STROKE_DASHARRAY
                                                              ],
                                                            cx: "21",
                                                            cy: "21",
                                                            r: "15.91549430918954",
                                                            fill: "transparent",
                                                          },
                                                        }),
                                                        _c("circle", {
                                                          staticClass:
                                                            "alert_severities2 donut-segment",
                                                          attrs: {
                                                            "stroke-dashoffset":
                                                              _vm
                                                                .acmDonutStyles[
                                                                _vm
                                                                  .ACM_UNIT_DONUT
                                                              ][
                                                                _vm.ACMHelper
                                                                  .SEVERITY2
                                                              ][
                                                                _vm.ACMHelper
                                                                  .STROKE_DASHOFFSET
                                                              ],
                                                            "stroke-dasharray":
                                                              _vm
                                                                .acmDonutStyles[
                                                                _vm
                                                                  .ACM_UNIT_DONUT
                                                              ][
                                                                _vm.ACMHelper
                                                                  .SEVERITY2
                                                              ][
                                                                _vm.ACMHelper
                                                                  .STROKE_DASHARRAY
                                                              ],
                                                            cx: "21",
                                                            cy: "21",
                                                            r: "15.91549430918954",
                                                            fill: "transparent",
                                                          },
                                                        }),
                                                        _c("circle", {
                                                          staticClass:
                                                            "alert_severities3 donut-segment",
                                                          attrs: {
                                                            "stroke-dashoffset":
                                                              _vm
                                                                .acmDonutStyles[
                                                                _vm
                                                                  .ACM_UNIT_DONUT
                                                              ][
                                                                _vm.ACMHelper
                                                                  .SEVERITY3
                                                              ][
                                                                _vm.ACMHelper
                                                                  .STROKE_DASHOFFSET
                                                              ],
                                                            "stroke-dasharray":
                                                              _vm
                                                                .acmDonutStyles[
                                                                _vm
                                                                  .ACM_UNIT_DONUT
                                                              ][
                                                                _vm.ACMHelper
                                                                  .SEVERITY3
                                                              ][
                                                                _vm.ACMHelper
                                                                  .STROKE_DASHARRAY
                                                              ],
                                                            cx: "21",
                                                            cy: "21",
                                                            r: "15.91549430918954",
                                                            fill: "transparent",
                                                          },
                                                        }),
                                                        _c("circle", {
                                                          staticClass:
                                                            "alert_severities4 donut-segment",
                                                          attrs: {
                                                            "stroke-dashoffset":
                                                              _vm
                                                                .acmDonutStyles[
                                                                _vm
                                                                  .ACM_UNIT_DONUT
                                                              ][
                                                                _vm.ACMHelper
                                                                  .SEVERITY4
                                                              ][
                                                                _vm.ACMHelper
                                                                  .STROKE_DASHOFFSET
                                                              ],
                                                            "stroke-dasharray":
                                                              _vm
                                                                .acmDonutStyles[
                                                                _vm
                                                                  .ACM_UNIT_DONUT
                                                              ][
                                                                _vm.ACMHelper
                                                                  .SEVERITY4
                                                              ][
                                                                _vm.ACMHelper
                                                                  .STROKE_DASHARRAY
                                                              ],
                                                            cx: "21",
                                                            cy: "21",
                                                            r: "15.91549430918954",
                                                            fill: "transparent",
                                                          },
                                                        }),
                                                        _c("circle", {
                                                          staticClass:
                                                            "alert_severities5 donut-segment",
                                                          attrs: {
                                                            "stroke-dashoffset":
                                                              _vm
                                                                .acmDonutStyles[
                                                                _vm
                                                                  .ACM_UNIT_DONUT
                                                              ][
                                                                _vm.ACMHelper
                                                                  .SEVERITY5
                                                              ][
                                                                _vm.ACMHelper
                                                                  .STROKE_DASHOFFSET
                                                              ],
                                                            "stroke-dasharray":
                                                              _vm
                                                                .acmDonutStyles[
                                                                _vm
                                                                  .ACM_UNIT_DONUT
                                                              ][
                                                                _vm.ACMHelper
                                                                  .SEVERITY5
                                                              ][
                                                                _vm.ACMHelper
                                                                  .STROKE_DASHARRAY
                                                              ],
                                                            cx: "21",
                                                            cy: "21",
                                                            r: "15.91549430918954",
                                                            fill: "transparent",
                                                          },
                                                        }),
                                                        _c("circle", {
                                                          staticClass:
                                                            "alert_severities6 donut-segment",
                                                          attrs: {
                                                            "stroke-dashoffset":
                                                              _vm
                                                                .acmDonutStyles[
                                                                _vm
                                                                  .ACM_UNIT_DONUT
                                                              ][
                                                                _vm.ACMHelper
                                                                  .SEVERITY6
                                                              ][
                                                                _vm.ACMHelper
                                                                  .STROKE_DASHOFFSET
                                                              ],
                                                            "stroke-dasharray":
                                                              _vm
                                                                .acmDonutStyles[
                                                                _vm
                                                                  .ACM_UNIT_DONUT
                                                              ][
                                                                _vm.ACMHelper
                                                                  .SEVERITY6
                                                              ][
                                                                _vm.ACMHelper
                                                                  .STROKE_DASHARRAY
                                                              ],
                                                            cx: "21",
                                                            cy: "21",
                                                            r: "15.91549430918954",
                                                            fill: "transparent",
                                                          },
                                                        }),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _c(
                                                  "span",
                                                  { staticClass: "label" },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "numAlert",
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass: "num",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.acmUnitItem
                                                                  .numberRedAlerts
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]),
                                ]
                              )
                            : _vm._e(),
                        ]),
                        _c("div", { staticClass: "row unit-buttons" }, [
                          _c("div", { staticClass: "col-12 pl-5" }, [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-sm add-item-btn",
                                attrs: {
                                  type: "button",
                                  "data-toggle": "modal",
                                  "data-target": "#plant-item-modal",
                                  disabled: _vm.isTableReadOnly(),
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.addPlantItem()
                                  },
                                },
                              },
                              [
                                _c("font-awesome-icon", {
                                  attrs: { icon: "plus" },
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "subtitle-buttons" },
                                  [_vm._v(_vm._s(_vm.$t("addPlantItem")))]
                                ),
                              ],
                              1
                            ),
                          ]),
                        ]),
                      ]),
                      _c("div", { staticClass: "row unit-buttons" }, [
                        _c("div", { staticClass: "col-12 pl-5" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-sm add-item-btn",
                              attrs: {
                                type: "button",
                                "data-toggle": "modal",
                                disabled: _vm.isTableReadOnly(),
                                "data-target": "#add-maintenance-item-modal",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.populateNewMaintenanceItemModal()
                                },
                              },
                            },
                            [
                              _c("font-awesome-icon", {
                                attrs: { icon: "plus" },
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "subtitle-buttons" }, [
                                _vm._v(_vm._s(_vm.$t("addMaintItem"))),
                              ]),
                            ],
                            1
                          ),
                        ]),
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-8 pl-5 ml-2 mb-2 input-group input-group-sm",
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model.lazy",
                                  value: _vm.tableSearchTerm,
                                  expression: "tableSearchTerm",
                                  modifiers: { lazy: true },
                                },
                              ],
                              staticClass: "form-control",
                              attrs: {
                                placeholder: _vm.$t("search"),
                                type: "text",
                              },
                              domProps: { value: _vm.tableSearchTerm },
                              on: {
                                keyup: function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  return _vm.tableSearch()
                                },
                                change: function ($event) {
                                  _vm.tableSearchTerm = $event.target.value
                                },
                              },
                            }),
                            _c("div", { staticClass: "input-group-append" }, [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-primary table-search-button",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.tableSearch()
                                    },
                                  },
                                },
                                [
                                  _c("font-awesome-icon", {
                                    attrs: { icon: "search" },
                                  }),
                                ],
                                1
                              ),
                            ]),
                          ]
                        ),
                        _c("div", { staticClass: "expand-button-wrapper" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-primary btn-sm",
                              attrs: { type: "button" },
                              on: { click: _vm.toggleOutages },
                            },
                            [
                              !_vm.expanded
                                ? _c(
                                    "span",
                                    { staticClass: "button-label" },
                                    [
                                      _vm.acmUnitItem.numberRedAlerts > 0
                                        ? _c(
                                            "span",
                                            { staticClass: "blink_me" },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(_vm.$t("pmhAlerts")) +
                                                  " "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm.acmUnitItem.numberRedAlerts <= 0
                                        ? _c("span", [
                                            _vm._v(
                                              " " +
                                                _vm._s(_vm.$t("pmhAlerts")) +
                                                " "
                                            ),
                                          ])
                                        : _vm._e(),
                                      _c("font-awesome-icon", {
                                        attrs: { icon: "angle-right" },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.expanded
                                ? _c(
                                    "span",
                                    [
                                      _c("font-awesome-icon", {
                                        attrs: { icon: "angle-left" },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ]
                          ),
                        ]),
                      ]),
                      _c("div", { staticClass: "row" }),
                    ]),
                  ]
                ),
                _c("div", { staticClass: "scrollable pl-0" }, [
                  _c("div", {
                    staticStyle: {
                      background: "white",
                      height: "20px",
                      "margin-left": "20px",
                    },
                    style: { width: _vm.tablewidth * 120 + 21 + "px" },
                  }),
                  _c(
                    "div",
                    {
                      staticClass: "table-header",
                      style: { width: _vm.tablewidth * 120 + 1 + "px" },
                    },
                    _vm._l(_vm.table.years, function (year) {
                      return _c(
                        "div",
                        { key: year.year, staticClass: "year-box" },
                        [
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col-12" }, [
                              _c(
                                "p",
                                { staticClass: "mb-1 text-center year" },
                                [_vm._v(" " + _vm._s(year.year) + " ")]
                              ),
                            ]),
                          ]),
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col" }, [
                              _c(
                                "span",
                                { staticClass: "align-center year-oh" },
                                [
                                  _c("font-awesome-icon", {
                                    attrs: { icon: "clock" },
                                  }),
                                  _c("span", [
                                    _vm._v(_vm._s(year.operatingHours)),
                                  ]),
                                ],
                                1
                              ),
                            ]),
                          ]),
                          _c(
                            "div",
                            { staticClass: "row mt-2 pl-1 pr-1 starts" },
                            [
                              _c(
                                "div",
                                { staticClass: "col-4 p-0" },
                                [
                                  _c("font-awesome-icon", {
                                    staticClass: "align-center",
                                    staticStyle: { color: "#c32022" },
                                    attrs: { icon: "chevron-circle-right" },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "col-4 p-0" },
                                [
                                  _c("font-awesome-icon", {
                                    staticClass: "align-center",
                                    staticStyle: { color: "#f7c118" },
                                    attrs: { icon: "chevron-circle-right" },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "col-4 p-0" },
                                [
                                  _c("font-awesome-icon", {
                                    staticClass: "align-center",
                                    staticStyle: { color: "#006ac2" },
                                    attrs: { icon: "chevron-circle-right" },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                          _c("div", { staticClass: "row pl-1 pr-1 numbers" }, [
                            _c("div", { staticClass: "col-4 p-0" }, [
                              _c("p", { staticClass: "align-center" }, [
                                _vm._v(" " + _vm._s(year.hotStarts) + " "),
                              ]),
                            ]),
                            _c("div", { staticClass: "col-4 p-0" }, [
                              _c("p", { staticClass: "align-center" }, [
                                _vm._v(" " + _vm._s(year.warmStarts) + " "),
                              ]),
                            ]),
                            _c("div", { staticClass: "col-4 p-0" }, [
                              _c("p", { staticClass: "align-center" }, [
                                _vm._v(" " + _vm._s(year.coldStarts) + " "),
                              ]),
                            ]),
                          ]),
                          _c("div", { staticClass: "grey-bottom" }),
                        ]
                      )
                    }),
                    0
                  ),
                ]),
              ]),
              _vm._l(_vm.table.areas, function (area, areaIndex) {
                return _c(
                  "div",
                  { key: areaIndex, staticClass: "areas mb-2" },
                  _vm._l(area.items, function (item, index) {
                    return _c(
                      "lazy-component",
                      {
                        key: index,
                        staticClass: "area-wrapper pl-0",
                        attrs: { id: "areaItemsWrapper-" + areaIndex },
                      },
                      [
                        _c(
                          "span",
                          {
                            attrs: { slot: "placeholder" },
                            slot: "placeholder",
                          },
                          [_vm._v(_vm._s(_vm.$t("loading")))]
                        ),
                        _c("div", { staticClass: "item-wrapper" }, [
                          _c(
                            "div",
                            {
                              staticClass: "_col-4 pl-3 item-div",
                              class: {
                                "area-first-border": index === 0,
                                "area-last-border":
                                  index === area.items.length - 1,
                                expanded: _vm.expanded,
                              },
                              style: { width: _vm.leftPaneWidth + "px" },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "row item-row",
                                  attrs: {
                                    id:
                                      "maintenanceItem-" +
                                      item.plantItemMaintenanceId,
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "col-3 py-1 area-name" },
                                    [
                                      index === 0
                                        ? _c(
                                            "div",
                                            { staticClass: "name-container" },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  attrs: {
                                                    "data-toggle": "tooltip",
                                                    "data-placement": "top",
                                                    title: area.name,
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "text-ovflow-ellipsis",
                                                    },
                                                    [_vm._v(_vm._s(area.name))]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                { staticClass: "progress" },
                                                [
                                                  _c("div", {
                                                    staticClass: "progress-bar",
                                                    class:
                                                      _vm.getProgressBarClass(
                                                        area.remainingLife
                                                      ),
                                                    style: {
                                                      width:
                                                        area.remainingLife +
                                                        "%",
                                                    },
                                                    attrs: {
                                                      role: "progressbar",
                                                      "aria-valuenow": "25",
                                                      "aria-valuemin": "0",
                                                      "aria-valuemax": "100",
                                                    },
                                                  }),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "percent",
                                                  class:
                                                    _vm.getProgressBarClass(
                                                      area.remainingLife
                                                    ),
                                                  style: {
                                                    "margin-left":
                                                      area.remainingLife -
                                                      20 -
                                                      4 +
                                                      "%",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        area.remainingLife
                                                      ) +
                                                      "% "
                                                  ),
                                                  _c("div", {
                                                    staticClass: "arrowdown",
                                                  }),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "pl-3 py-2 pr-0 item-details",
                                      class: _vm.getPlantItemClass(
                                        index,
                                        area,
                                        true
                                      ),
                                    },
                                    [
                                      _vm.isFirstPlantItem(index, area)
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "plant-item text-ovflow-ellipsis",
                                            },
                                            [
                                              _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "btn btn-primary btn-sm table-edit-item",
                                                  attrs: {
                                                    "data-toggle": "modal",
                                                    "data-target":
                                                      "#plant-item-modal",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.editPlantItem(
                                                        item
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("font-awesome-icon", {
                                                    attrs: { icon: "edit" },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _vm._v(
                                                " " +
                                                  _vm._s(item.plantItem) +
                                                  " "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _c(
                                        "p",
                                        {
                                          staticClass:
                                            "mt-1 ml-3 mb-0 maintenance-type text-ovflow-ellipsis",
                                        },
                                        [
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "btn btn-primary btn-sm table-edit-item",
                                              attrs: {
                                                "data-toggle": "modal",
                                                "data-target":
                                                  "#add-maintenance-item-modal",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.editMaintenanceItem(
                                                    item
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("font-awesome-icon", {
                                                attrs: { icon: "edit" },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c("span", [
                                            item.maintenanceDescription
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "text-ovflow-ellipsis",
                                                    attrs: {
                                                      title:
                                                        item.maintenanceDescription,
                                                      "data-toggle": "tooltip",
                                                      "data-placement": "top",
                                                      "data-original-title":
                                                        item.maintenanceDescription,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          item.maintenanceDescription
                                                        )
                                                    ),
                                                    _c("br"),
                                                  ]
                                                )
                                              : _vm._e(),
                                            item.projectName
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "text-ovflow-ellipsis",
                                                    attrs: {
                                                      "data-toggle": "tooltip",
                                                      "data-placement": "top",
                                                      "data-original-title":
                                                        item.projectName,
                                                      title: item.projectName,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " (" +
                                                        _vm._s(
                                                          item.projectName
                                                        ) +
                                                        ")"
                                                    ),
                                                    _c("br"),
                                                  ]
                                                )
                                              : _vm._e(),
                                            !item.projectName
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "text-ovflow-ellipsis",
                                                    attrs: {
                                                      "data-toggle": "tooltip",
                                                      "data-placement": "top",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " (" +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "noPmlConnection"
                                                          )
                                                        ) +
                                                        ")"
                                                    ),
                                                    _c("br"),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _c(
                                              "span",
                                              {
                                                attrs: {
                                                  "data-toggle": "tooltip",
                                                  "data-placement": "left",
                                                  title: _vm.$t(
                                                    "maintenanceActivity"
                                                  ),
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      item.categoryString[0]
                                                    ) +
                                                    " - " +
                                                    _vm._s(
                                                      item.maintenanceActivityString
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                            item.linked === true &&
                                            item.maintenanceGroupType ===
                                              _vm.maintenanceGroupTypes
                                                .ALTERNATE
                                              ? _c(
                                                  "span",
                                                  [
                                                    _c("font-awesome-icon", {
                                                      staticClass:
                                                        "ml-1 text-secondary",
                                                      attrs: { icon: "link" },
                                                    }),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                            item.linked === true &&
                                            item.maintenanceGroupType ===
                                              _vm.maintenanceGroupTypes.PARALLEL
                                              ? _c("span", [
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "linked-link",
                                                      attrs: {
                                                        href: "javascript:void(0)",
                                                        "data-toggle":
                                                          "tooltip",
                                                        "data-placement": "top",
                                                        title:
                                                          _vm.getParallelMaintenanceTitles(
                                                            area.items,
                                                            item.plantItemMaintenanceId,
                                                            item.maintenanceGroupId
                                                          ),
                                                      },
                                                      on: {
                                                        mouseover: function (
                                                          $event
                                                        ) {
                                                          return _vm.highlightGroupedItems(
                                                            area.items,
                                                            item.maintenanceGroupId
                                                          )
                                                        },
                                                        mouseout: function (
                                                          $event
                                                        ) {
                                                          return _vm.unHighlightGroupedItems(
                                                            area.items,
                                                            item.maintenanceGroupId
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c("font-awesome-icon", {
                                                        staticClass: "ml-1",
                                                        attrs: { icon: "link" },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ])
                                              : _vm._e(),
                                            item.linked === true &&
                                            item.maintenanceGroupType ===
                                              _vm.maintenanceGroupTypes.SUPPORT
                                              ? _c(
                                                  "span",
                                                  [
                                                    _c("font-awesome-icon", {
                                                      staticClass:
                                                        "ml-1 text-warning",
                                                      attrs: { icon: "link" },
                                                    }),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                          ]),
                                          _vm.isPtRisk(item)
                                            ? _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "btn btn-primary btn-sm table-edit-item",
                                                  attrs: {
                                                    "data-toggle": "modal",
                                                    "data-target":
                                                      "#plant-item-risk-details-modal",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.showRiskDetailsModal(
                                                        item
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("font-awesome-icon", {
                                                    attrs: { icon: "bell" },
                                                  }),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm.isOpportunity(item)
                                            ? _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "btn btn-primary btn-sm table-edit-item",
                                                  attrs: {
                                                    "data-toggle": "modal",
                                                    "data-target":
                                                      "#plant-item-opportunity-details-modal",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.showOpportunityDetailsModal(
                                                        item
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("font-awesome-icon", {
                                                    attrs: { icon: "bell" },
                                                  }),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                        ]
                                      ),
                                      _c(
                                        "p",
                                        {
                                          staticClass: "item-text ml-3 mb-0",
                                          class: [
                                            item.driver2 === null
                                              ? "mt-1"
                                              : "mt-0",
                                          ],
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              attrs: {
                                                "data-toggle": "tooltip",
                                                "data-placement": "left",
                                                title: _vm.$t("driver"),
                                              },
                                            },
                                            [
                                              _c("font-awesome-icon", {
                                                staticClass: "light-blue",
                                                attrs: { icon: "user" },
                                              }),
                                              _vm._v(
                                                " " +
                                                  _vm._s(item.driverString) +
                                                  " "
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "span",
                                            {
                                              attrs: {
                                                "data-toggle": "tooltip",
                                                "data-placement": "right",
                                                title: _vm.$t("model"),
                                              },
                                            },
                                            [
                                              item.model != null
                                                ? _c("font-awesome-icon", {
                                                    staticClass: "light-blue",
                                                    attrs: { icon: "cube" },
                                                  })
                                                : _vm._e(),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.mapModelDriver(
                                                      item.model
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "p",
                                        { staticClass: "item-text mb-0 ml-3" },
                                        [
                                          _c(
                                            "span",
                                            {
                                              attrs: {
                                                "data-toggle": "tooltip",
                                                "data-placement": "bottom",
                                                title: _vm.$t("interval"),
                                              },
                                            },
                                            [
                                              _c("font-awesome-icon", {
                                                staticClass: "light-blue",
                                                attrs: { icon: "stopwatch" },
                                              }),
                                              _vm._v(
                                                " " +
                                                  _vm._s(item.intervalString) +
                                                  " "
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "span",
                                            {
                                              attrs: {
                                                "data-toggle": "tooltip",
                                                "data-placement": "bottom",
                                                title: _vm.$t("tolerance"),
                                              },
                                            },
                                            [
                                              _c("font-awesome-icon", {
                                                staticClass: "light-blue",
                                                attrs: { icon: "plus" },
                                              }),
                                              _vm._v(
                                                " " +
                                                  _vm._s(item.tolerance) +
                                                  "% "
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "span",
                                            {
                                              attrs: {
                                                "data-toggle": "tooltip",
                                                "data-placement": "bottom",
                                                title: _vm.$t("cost"),
                                              },
                                            },
                                            [
                                              _c("font-awesome-icon", {
                                                staticClass: "light-blue",
                                                attrs: {
                                                  icon: "money-bill-alt",
                                                },
                                              }),
                                              _c("span", [
                                                _vm._v(_vm._s(item.cost)),
                                              ]),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "span",
                                            {
                                              attrs: {
                                                "data-toggle": "tooltip",
                                                "data-placement": "bottom",
                                                title: _vm.$t("duration"),
                                              },
                                            },
                                            [
                                              _c("font-awesome-icon", {
                                                staticClass: "light-blue",
                                                attrs: { icon: "stopwatch" },
                                              }),
                                              _vm._v(
                                                " " +
                                                  _vm._s(item.duration) +
                                                  " "
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                      _vm.objectHelper.propertyValueExists(
                                        item.driver2
                                      )
                                        ? [
                                            _c(
                                              "p",
                                              {
                                                staticClass:
                                                  "item-text mt-0 mb-0 ml-3",
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    attrs: {
                                                      "data-toggle": "tooltip",
                                                      "data-placement": "left",
                                                      title: _vm.$t("driver"),
                                                    },
                                                  },
                                                  [
                                                    _c("font-awesome-icon", {
                                                      staticClass: "light-blue",
                                                      attrs: { icon: "user" },
                                                    }),
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          item.driverString2
                                                        ) +
                                                        " "
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    attrs: {
                                                      "data-toggle": "tooltip",
                                                      "data-placement": "right",
                                                      title: _vm.$t("model"),
                                                    },
                                                  },
                                                  [
                                                    item.model2 != null
                                                      ? _c(
                                                          "font-awesome-icon",
                                                          {
                                                            staticClass:
                                                              "light-blue",
                                                            attrs: {
                                                              icon: "cube",
                                                            },
                                                          }
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          item.modelString2
                                                        ) +
                                                        " "
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "p",
                                              {
                                                staticClass:
                                                  "item-text mb-0 ml-3",
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    attrs: {
                                                      "data-toggle": "tooltip",
                                                      "data-placement":
                                                        "bottom",
                                                      title: _vm.$t("interval"),
                                                    },
                                                  },
                                                  [
                                                    _c("font-awesome-icon", {
                                                      staticClass: "light-blue",
                                                      attrs: {
                                                        icon: "stopwatch",
                                                      },
                                                    }),
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          item.intervalString2
                                                        ) +
                                                        " "
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    attrs: {
                                                      "data-toggle": "tooltip",
                                                      "data-placement":
                                                        "bottom",
                                                      title:
                                                        _vm.$t("tolerance"),
                                                    },
                                                  },
                                                  [
                                                    _c("font-awesome-icon", {
                                                      staticClass: "light-blue",
                                                      attrs: { icon: "plus" },
                                                    }),
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          item.tolerance2
                                                        ) +
                                                        "% "
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    attrs: {
                                                      "data-toggle": "tooltip",
                                                      "data-placement":
                                                        "bottom",
                                                      title: _vm.$t("cost"),
                                                    },
                                                  },
                                                  [
                                                    _c("font-awesome-icon", {
                                                      staticClass: "light-blue",
                                                      attrs: {
                                                        icon: "money-bill-alt",
                                                      },
                                                    }),
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(item.cost) +
                                                        " "
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    attrs: {
                                                      "data-toggle": "tooltip",
                                                      "data-placement":
                                                        "bottom",
                                                      title: _vm.$t("duration"),
                                                    },
                                                  },
                                                  [
                                                    _c("font-awesome-icon", {
                                                      staticClass: "light-blue",
                                                      attrs: {
                                                        icon: "stopwatch",
                                                      },
                                                    }),
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(item.duration) +
                                                        " "
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            ),
                                          ]
                                        : _vm._e(),
                                    ],
                                    2
                                  ),
                                  _vm.expanded
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-2 py-2 pr-0 remaining-donut-container",
                                          class: _vm.getPlantItemClass(
                                            index,
                                            area
                                          ),
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "remaining-donut",
                                              attrs: {
                                                "data-toggle": "tooltip",
                                                "data-placement": "right",
                                                title: _vm.$t("remainingLife"),
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "donut-size",
                                                  attrs: {
                                                    id:
                                                      "specificChart-" +
                                                      areaIndex +
                                                      "-" +
                                                      index,
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "pie-remaining",
                                                    },
                                                    [
                                                      _c(
                                                        "svg",
                                                        {
                                                          staticClass:
                                                            "donut shadow",
                                                          attrs: {
                                                            width: "100%",
                                                            height: "100%",
                                                            viewBox:
                                                              "5 5 32 32",
                                                          },
                                                        },
                                                        [
                                                          _c("circle", {
                                                            staticClass:
                                                              "donut-hole",
                                                            attrs: {
                                                              cx: "21",
                                                              cy: "21",
                                                              r: "15.91549430918954",
                                                              fill: "#fff",
                                                            },
                                                          }),
                                                          _c("circle", {
                                                            staticClass:
                                                              "donut-ring",
                                                            attrs: {
                                                              cx: "21",
                                                              cy: "21",
                                                              r: "15.91549430918954",
                                                              fill: "transparent",
                                                              stroke: "#d2d3d4",
                                                            },
                                                          }),
                                                          _c("circle", {
                                                            staticClass:
                                                              "remaining donut-segment",
                                                            class:
                                                              _vm.getDonutChartClass(
                                                                item.remainingLife
                                                              ),
                                                            style: {
                                                              "stroke-dasharray":
                                                                _vm.getDonutChartStrokeDasharray(
                                                                  item.remainingLife
                                                                ),
                                                            },
                                                            attrs: {
                                                              cx: "21",
                                                              cy: "21",
                                                              r: "15.91549430918954",
                                                              fill: "transparent",
                                                              "stroke-dashoffset":
                                                                "25",
                                                            },
                                                          }),
                                                        ]
                                                      ),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass: "label",
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "num",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  item.remainingLife
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "smaller",
                                                            },
                                                            [_vm._v("%")]
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "p",
                                            {
                                              staticClass: "item-text totaloh",
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  attrs: {
                                                    "data-toggle": "tooltip",
                                                    "data-placement": "right",
                                                    title: _vm.$t("totalOH"),
                                                  },
                                                },
                                                [
                                                  _c("font-awesome-icon", {
                                                    staticClass: "light-blue",
                                                    attrs: { icon: "clock" },
                                                  }),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(item.totalOH) +
                                                      " "
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "p",
                                            { staticClass: "item-text mt-2" },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  attrs: {
                                                    "data-toggle": "tooltip",
                                                    "data-placement": "right",
                                                    title:
                                                      _vm.$t("nextMaintDate"),
                                                  },
                                                },
                                                [
                                                  item !== null &&
                                                  item.nextMaintenanceDate !==
                                                    ""
                                                    ? _c(
                                                        "span",
                                                        [
                                                          _c(
                                                            "font-awesome-icon",
                                                            {
                                                              staticClass:
                                                                "light-blue",
                                                              attrs: {
                                                                icon: "calendar-alt",
                                                              },
                                                            }
                                                          ),
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                item.nextMaintenanceDate
                                                              ) +
                                                              " "
                                                          ),
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.expanded,
                                          expression: "expanded",
                                        },
                                      ],
                                      staticClass:
                                        "col-2 py-2 pr-0 acm-donut-container",
                                      class: _vm.getPlantItemClass(index, area),
                                    },
                                    [
                                      _vm.isFirstPlantItem(index, area) &&
                                      _vm.hasValidACMCode(item.enerlyticsId)
                                        ? _c(
                                            "span",
                                            {
                                              attrs: {
                                                id:
                                                  "acmDonutContainer-" +
                                                  areaIndex +
                                                  "-" +
                                                  index,
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "acm-donut",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.showACMTooltip(
                                                        item
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "donut-size",
                                                      attrs: {
                                                        id:
                                                          "acmChart-" +
                                                          areaIndex +
                                                          "-" +
                                                          index,
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "pie-acm",
                                                        },
                                                        [
                                                          _vm.acmDonutStyles &&
                                                          _vm.acmDonutStyles[
                                                            areaIndex
                                                          ] &&
                                                          _vm.acmDonutStyles[
                                                            areaIndex
                                                          ][index]
                                                            ? _c(
                                                                "svg",
                                                                {
                                                                  staticClass:
                                                                    "donut shadow",
                                                                  attrs: {
                                                                    width:
                                                                      "100%",
                                                                    height:
                                                                      "100%",
                                                                    viewBox:
                                                                      "5 5 32 32",
                                                                  },
                                                                },
                                                                [
                                                                  _c("circle", {
                                                                    staticClass:
                                                                      "donut-hole",
                                                                    attrs: {
                                                                      cx: "21",
                                                                      cy: "21",
                                                                      r: "15.91549430918954",
                                                                      fill: "#fff",
                                                                    },
                                                                  }),
                                                                  _c("circle", {
                                                                    staticClass:
                                                                      "donut-ring",
                                                                    attrs: {
                                                                      cx: "21",
                                                                      cy: "21",
                                                                      r: "15.91549430918954",
                                                                      fill: "transparent",
                                                                      stroke:
                                                                        "#d2d3d4",
                                                                    },
                                                                  }),
                                                                  _c("circle", {
                                                                    staticClass:
                                                                      "alert_severities1 donut-segment",
                                                                    attrs: {
                                                                      "stroke-dashoffset":
                                                                        _vm
                                                                          .acmDonutStyles[
                                                                          areaIndex
                                                                        ][
                                                                          index
                                                                        ][
                                                                          _vm
                                                                            .ACMHelper
                                                                            .SEVERITY1
                                                                        ][
                                                                          _vm
                                                                            .ACMHelper
                                                                            .STROKE_DASHOFFSET
                                                                        ],
                                                                      "stroke-dasharray":
                                                                        _vm
                                                                          .acmDonutStyles[
                                                                          areaIndex
                                                                        ][
                                                                          index
                                                                        ][
                                                                          _vm
                                                                            .ACMHelper
                                                                            .SEVERITY1
                                                                        ][
                                                                          _vm
                                                                            .ACMHelper
                                                                            .STROKE_DASHARRAY
                                                                        ],
                                                                      cx: "21",
                                                                      cy: "21",
                                                                      r: "15.91549430918954",
                                                                      fill: "transparent",
                                                                    },
                                                                  }),
                                                                  _c("circle", {
                                                                    staticClass:
                                                                      "alert_severities2 donut-segment",
                                                                    attrs: {
                                                                      "stroke-dashoffset":
                                                                        _vm
                                                                          .acmDonutStyles[
                                                                          areaIndex
                                                                        ][
                                                                          index
                                                                        ][
                                                                          _vm
                                                                            .ACMHelper
                                                                            .SEVERITY2
                                                                        ][
                                                                          _vm
                                                                            .ACMHelper
                                                                            .STROKE_DASHOFFSET
                                                                        ],
                                                                      "stroke-dasharray":
                                                                        _vm
                                                                          .acmDonutStyles[
                                                                          areaIndex
                                                                        ][
                                                                          index
                                                                        ][
                                                                          _vm
                                                                            .ACMHelper
                                                                            .SEVERITY2
                                                                        ][
                                                                          _vm
                                                                            .ACMHelper
                                                                            .STROKE_DASHARRAY
                                                                        ],
                                                                      cx: "21",
                                                                      cy: "21",
                                                                      r: "15.91549430918954",
                                                                      fill: "transparent",
                                                                    },
                                                                  }),
                                                                  _c("circle", {
                                                                    staticClass:
                                                                      "alert_severities3 donut-segment",
                                                                    attrs: {
                                                                      "stroke-dashoffset":
                                                                        _vm
                                                                          .acmDonutStyles[
                                                                          areaIndex
                                                                        ][
                                                                          index
                                                                        ][
                                                                          _vm
                                                                            .ACMHelper
                                                                            .SEVERITY3
                                                                        ][
                                                                          _vm
                                                                            .ACMHelper
                                                                            .STROKE_DASHOFFSET
                                                                        ],
                                                                      "stroke-dasharray":
                                                                        _vm
                                                                          .acmDonutStyles[
                                                                          areaIndex
                                                                        ][
                                                                          index
                                                                        ][
                                                                          _vm
                                                                            .ACMHelper
                                                                            .SEVERITY3
                                                                        ][
                                                                          _vm
                                                                            .ACMHelper
                                                                            .STROKE_DASHARRAY
                                                                        ],
                                                                      cx: "21",
                                                                      cy: "21",
                                                                      r: "15.91549430918954",
                                                                      fill: "transparent",
                                                                    },
                                                                  }),
                                                                  _c("circle", {
                                                                    staticClass:
                                                                      "alert_severities4 donut-segment",
                                                                    attrs: {
                                                                      "stroke-dashoffset":
                                                                        _vm
                                                                          .acmDonutStyles[
                                                                          areaIndex
                                                                        ][
                                                                          index
                                                                        ][
                                                                          _vm
                                                                            .ACMHelper
                                                                            .SEVERITY4
                                                                        ][
                                                                          _vm
                                                                            .ACMHelper
                                                                            .STROKE_DASHOFFSET
                                                                        ],
                                                                      "stroke-dasharray":
                                                                        _vm
                                                                          .acmDonutStyles[
                                                                          areaIndex
                                                                        ][
                                                                          index
                                                                        ][
                                                                          _vm
                                                                            .ACMHelper
                                                                            .SEVERITY4
                                                                        ][
                                                                          _vm
                                                                            .ACMHelper
                                                                            .STROKE_DASHARRAY
                                                                        ],
                                                                      cx: "21",
                                                                      cy: "21",
                                                                      r: "15.91549430918954",
                                                                      fill: "transparent",
                                                                    },
                                                                  }),
                                                                  _c("circle", {
                                                                    staticClass:
                                                                      "alert_severities5 donut-segment",
                                                                    attrs: {
                                                                      "stroke-dashoffset":
                                                                        _vm
                                                                          .acmDonutStyles[
                                                                          areaIndex
                                                                        ][
                                                                          index
                                                                        ][
                                                                          _vm
                                                                            .ACMHelper
                                                                            .SEVERITY5
                                                                        ][
                                                                          _vm
                                                                            .ACMHelper
                                                                            .STROKE_DASHOFFSET
                                                                        ],
                                                                      "stroke-dasharray":
                                                                        _vm
                                                                          .acmDonutStyles[
                                                                          areaIndex
                                                                        ][
                                                                          index
                                                                        ][
                                                                          _vm
                                                                            .ACMHelper
                                                                            .SEVERITY5
                                                                        ][
                                                                          _vm
                                                                            .ACMHelper
                                                                            .STROKE_DASHARRAY
                                                                        ],
                                                                      cx: "21",
                                                                      cy: "21",
                                                                      r: "15.91549430918954",
                                                                      fill: "transparent",
                                                                    },
                                                                  }),
                                                                  _c("circle", {
                                                                    staticClass:
                                                                      "alert_severities6 donut-segment",
                                                                    attrs: {
                                                                      cx: "21",
                                                                      cy: "21",
                                                                      r: "15.91549430918954",
                                                                      fill: "transparent",
                                                                      "stroke-dashoffset":
                                                                        "125",
                                                                      "stroke-dasharray":
                                                                        "0 100",
                                                                    },
                                                                  }),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "label",
                                                            },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "numAlert",
                                                                },
                                                                [
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "num",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          item.numberRedAlerts
                                                                        )
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "item-text totaloh",
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      attrs: {
                                                        "data-toggle":
                                                          "tooltip",
                                                        "data-placement":
                                                          "right",
                                                        title:
                                                          _vm.$t("totalOH"),
                                                      },
                                                    },
                                                    [
                                                      _c("font-awesome-icon", {
                                                        staticClass:
                                                          "light-blue",
                                                        attrs: {
                                                          icon: "clock",
                                                        },
                                                      }),
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(item.totalOH) +
                                                          " "
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "p",
                                                {
                                                  staticClass: "item-text mt-2",
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      attrs: {
                                                        "data-toggle":
                                                          "tooltip",
                                                        "data-placement":
                                                          "right",
                                                        title:
                                                          _vm.$t(
                                                            "nextMaintDate"
                                                          ),
                                                      },
                                                    },
                                                    [
                                                      item !== null &&
                                                      item.nextMaintenanceDate !==
                                                        ""
                                                        ? _c(
                                                            "span",
                                                            [
                                                              _c(
                                                                "font-awesome-icon",
                                                                {
                                                                  staticClass:
                                                                    "light-blue",
                                                                  attrs: {
                                                                    icon: "calendar-alt",
                                                                  },
                                                                }
                                                              ),
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    item.nextMaintenanceDate
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _c("div", { staticClass: "scrollable pl-0" }, [
                            _c(
                              "div",
                              {
                                class: [
                                  "item-cell-wrapper",
                                  (areaIndex + index) % 2 === 0
                                    ? "bg-white"
                                    : "bg-gray",
                                  index === 0 ? "bordertop" : "",
                                ],
                                style: {
                                  width: _vm.tablewidth * 120 + 21 + "px",
                                },
                              },
                              _vm._l(item.years, function (year) {
                                return _c(
                                  "div",
                                  {
                                    key: year.year,
                                    staticClass: "item-cell",
                                    attrs: {
                                      id:
                                        "plantItemMaintenanceYear-" +
                                        item.plantItemMaintenanceId +
                                        "-" +
                                        year.year,
                                    },
                                  },
                                  [
                                    _c("div", { staticClass: "row" }, [
                                      _c(
                                        "div",
                                        { staticClass: "col-11 row__content" },
                                        [
                                          _c("div", {
                                            staticClass: "left-corner-triangle",
                                            class: _vm.setBackgroundClass(year),
                                          }),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "item-cell-year top",
                                            },
                                            [
                                              _c("span"),
                                              _vm.isYearsTooltipVisible(
                                                year,
                                                item
                                              )
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "item-cell-year__tooltip",
                                                      attrs: {
                                                        "data-placement":
                                                          "bottom",
                                                        title:
                                                          _vm.generateTooltipName(
                                                            year,
                                                            item
                                                          ),
                                                      },
                                                    },
                                                    [
                                                      _vm.getDriverIcon(
                                                        item.driver
                                                      ) !== ""
                                                        ? _c(
                                                            "font-awesome-icon",
                                                            {
                                                              staticStyle: {
                                                                "padding-right":
                                                                  "3px",
                                                              },
                                                              style: {
                                                                color:
                                                                  year.intervalExceeded
                                                                    ? "#dc3545"
                                                                    : "#0078dc",
                                                              },
                                                              attrs: {
                                                                icon: _vm.getDriverIcon(
                                                                  item.driver
                                                                ),
                                                              },
                                                            }
                                                          )
                                                        : _vm._e(),
                                                      _c(
                                                        "span",
                                                        {
                                                          class: [
                                                            "summed-value",
                                                            {
                                                              "summed-value-double":
                                                                _vm.objectHelper.propertyValueExists(
                                                                  item.driver2
                                                                ),
                                                            },
                                                          ],
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                year.summedValue
                                                              ) +
                                                              " "
                                                          ),
                                                          _vm.objectHelper.propertyValueExists(
                                                            item.driver2
                                                          )
                                                            ? [
                                                                _vm._v(
                                                                  " (" +
                                                                    _vm._s(
                                                                      year.summedValue2
                                                                    ) +
                                                                    ") "
                                                                ),
                                                              ]
                                                            : _vm._e(),
                                                        ],
                                                        2
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                            ]
                                          ),
                                          year.history.length > 0 &&
                                          year.calculatedMaintenances.length ===
                                            0
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "item-cell-year pl-1",
                                                  attrs: {
                                                    "data-toggle": "tooltip",
                                                    "data-placement": "top",
                                                    title: _vm.$t("history"),
                                                  },
                                                },
                                                [
                                                  _c("font-awesome-icon", {
                                                    attrs: { icon: "history" },
                                                  }),
                                                  _vm._v(
                                                    "  " +
                                                      _vm._s(
                                                        _vm.getTranslatedMonth(
                                                          _vm.getMonth(
                                                            year.history[
                                                              year.history
                                                                .length - 1
                                                            ].maintenanceDate
                                                          )
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "calculated-maintenances-container",
                                            },
                                            [
                                              year.calculatedMaintenances
                                                .length < 2
                                                ? [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "item-cell-year pl-1",
                                                        attrs: {
                                                          "data-toggle":
                                                            "tooltip",
                                                          "data-placement":
                                                            "left",
                                                          title:
                                                            _vm.getCalculatedMessage(
                                                              item,
                                                              year
                                                            ),
                                                        },
                                                      },
                                                      [
                                                        year
                                                          .calculatedMaintenances
                                                          .length > 0
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "item-cell-year-text",
                                                              },
                                                              [
                                                                _c(
                                                                  "font-awesome-icon",
                                                                  {
                                                                    attrs: {
                                                                      icon: "calculator",
                                                                    },
                                                                  }
                                                                ),
                                                                _vm._v(
                                                                  "  " +
                                                                    _vm._s(
                                                                      _vm.getTranslatedMonth(
                                                                        _vm.getMonth(
                                                                          year
                                                                            .calculatedMaintenances[
                                                                            year
                                                                              .calculatedMaintenances
                                                                              .length -
                                                                              1
                                                                          ]
                                                                            .maintenanceDate
                                                                        )
                                                                      )
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ],
                                                              1
                                                            )
                                                          : _vm._e(),
                                                        year
                                                          .calculatedMaintenances
                                                          .length > 0 &&
                                                        year
                                                          .calculatedMaintenances[
                                                          year
                                                            .calculatedMaintenances
                                                            .length - 1
                                                        ].outageId !== null
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "item-cell-year-text",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      year
                                                                        .calculatedMaintenances[
                                                                        year
                                                                          .calculatedMaintenances
                                                                          .length -
                                                                          1
                                                                      ].outageId
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        year
                                                          .calculatedMaintenances
                                                          .length > 0 &&
                                                        year
                                                          .calculatedMaintenances[
                                                          year
                                                            .calculatedMaintenances
                                                            .length - 1
                                                        ]
                                                          .linkedPlantItemsMaintenancePlanningId !==
                                                          0
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "item-cell-year-text",
                                                              },
                                                              [
                                                                year
                                                                  .calculatedMaintenances
                                                                  .length > 0 &&
                                                                year
                                                                  .calculatedMaintenances[
                                                                  year
                                                                    .calculatedMaintenances
                                                                    .length - 1
                                                                ]
                                                                  .leadingItem ===
                                                                  true
                                                                  ? _c("span", {
                                                                      staticClass:
                                                                        "isLeadingItem",
                                                                    })
                                                                  : _vm._e(),
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm.getTranslatedMonth(
                                                                        _vm.getMonth(
                                                                          year
                                                                            .calculatedMaintenances[
                                                                            year
                                                                              .calculatedMaintenances
                                                                              .length -
                                                                              1
                                                                          ]
                                                                            .linkedPlantItemsMaintenancePlanningDate
                                                                        )
                                                                      )
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ]
                                                    ),
                                                  ]
                                                : _vm._l(
                                                    year.calculatedMaintenances,
                                                    function (calc, indexCalc) {
                                                      return _c(
                                                        "div",
                                                        {
                                                          key: indexCalc,
                                                          staticClass:
                                                            "item-cell-year pl-1",
                                                          attrs: {
                                                            "data-placement":
                                                              "top",
                                                            title:
                                                              (calc.outageId
                                                                ? calc.outageId +
                                                                  " "
                                                                : _vm.$t(
                                                                    "calculatedField"
                                                                  )) +
                                                              (calc.linkedPlantItemsMaintenancePlanningId !==
                                                              0
                                                                ? _vm.getTranslatedMonth(
                                                                    _vm.getMonth(
                                                                      calc.linkedPlantItemsMaintenancePlanningDate
                                                                    )
                                                                  )
                                                                : ""),
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "font-awesome-icon",
                                                            {
                                                              attrs: {
                                                                icon: "calculator",
                                                              },
                                                            }
                                                          ),
                                                          _vm._v(
                                                            "  " +
                                                              _vm._s(
                                                                _vm.getTranslatedMonth(
                                                                  _vm.getMonth(
                                                                    calc.maintenanceDate
                                                                  )
                                                                )
                                                              ) +
                                                              " "
                                                          ),
                                                        ],
                                                        1
                                                      )
                                                    }
                                                  ),
                                            ],
                                            2
                                          ),
                                          year.calculatedMaintenances.length >
                                            0 &&
                                          item.linked === true &&
                                          item.maintenanceGroupType ===
                                            _vm.maintenanceGroupTypes.ALTERNATE
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "item-cell-year pl-1 next-item-link",
                                                  on: {
                                                    mouseover: function (
                                                      $event
                                                    ) {
                                                      return _vm.highlightNextMaintenanceYears(
                                                        area.items,
                                                        item,
                                                        year
                                                      )
                                                    },
                                                    mouseout: function (
                                                      $event
                                                    ) {
                                                      return _vm.unHighlightNextMaintenanceYears()
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "linked-blue",
                                                      attrs: {
                                                        "data-toggle":
                                                          "tooltip",
                                                        "data-placement":
                                                          "bottom",
                                                        title:
                                                          _vm.getAlternateMaintenanceTitle(
                                                            area.items,
                                                            year
                                                          ),
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t("trigger")
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          year.calculatedMaintenances.length >
                                            0 &&
                                          item.linked === true &&
                                          item.maintenanceGroupType ===
                                            _vm.maintenanceGroupTypes.PARALLEL
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "item-cell-year pl-1 next-item-link",
                                                  attrs: {
                                                    title:
                                                      _vm.getParallelMaintenanceTitles(
                                                        area.items,
                                                        item.plantItemMaintenanceId,
                                                        item.maintenanceGroupId
                                                      ),
                                                    "data-toggle": "tooltip",
                                                    "data-placement": "bottom",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "linked-blue",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(_vm.$t("linked"))
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          year.calculatedMaintenances.length >
                                            0 &&
                                          item.linked === true &&
                                          item.maintenanceGroupType ===
                                            _vm.maintenanceGroupTypes.SUPPORT
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "item-cell-year pl-1 next-item-link",
                                                  attrs: {
                                                    title:
                                                      _vm.getSupportMaintenanceTitles(
                                                        area.items,
                                                        item.plantItemMaintenanceId,
                                                        item.maintenanceGroupId
                                                      ),
                                                    "data-toggle": "tooltip",
                                                    "data-placement": "bottom",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "linked-blue",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(_vm.$t("linked"))
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      ),
                                      _c("div", { staticClass: "col-1" }, [
                                        item.driver !== _vm.driverTypes.Once
                                          ? _c(
                                              "div",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value:
                                                      year.remainingLife > 0,
                                                    expression:
                                                      "year.remainingLife > 0",
                                                  },
                                                ],
                                                staticClass:
                                                  "progress progress-bar-vertical",
                                              },
                                              [
                                                _c("div", {
                                                  class:
                                                    _vm.getProgressBarClass(
                                                      year.remainingLife
                                                    ),
                                                  style: {
                                                    height:
                                                      year.remainingLife + "%",
                                                  },
                                                  attrs: {
                                                    role: "progressbar",
                                                    "aria-valuenow":
                                                      year.remainingLife,
                                                    "aria-valuemin": "0",
                                                    "aria-valuemax": "100",
                                                  },
                                                }),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]),
                                    ]),
                                  ]
                                )
                              }),
                              0
                            ),
                          ]),
                        ]),
                      ]
                    )
                  }),
                  1
                )
              }),
              _c("plant-item-modal"),
              _c("plant-item-maintenance-modal"),
              _c("plant-item-risk-details-modal"),
              _c("plant-item-opportunity-details-modal"),
            ],
            2
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }